import type { DragItem, DropItem } from '@react-types/shared';

/** Resources dragged out of a picker, for a collection that takes them (a shortlist). */
export const RESOURCE_DRAG_TYPE = 'application/x-atellio-resource';

export interface DraggedResource {
  id: number;
  name: string;
}

export const resourceDrag = {
  /** One drag item per resource; plain text too, so a drop elsewhere reads as their names. */
  itemsOf: (resources: DraggedResource[]): DragItem[] =>
    resources.map(resource => ({
      [RESOURCE_DRAG_TYPE]: JSON.stringify(resource),
      'text/plain': resource.name
    })),

  /** The resources a drag of ours carries, from its own items (for its preview). */
  ofItems: (items: DragItem[]): DraggedResource[] =>
    items.flatMap(item =>
      item[RESOURCE_DRAG_TYPE]
        ? [JSON.parse(item[RESOURCE_DRAG_TYPE]) as DraggedResource]
        : []
    ),

  /** The resources among the dropped items, in the order they came; anything else is left out. */
  read: async (items: DropItem[]): Promise<DraggedResource[]> => {
    const read = await Promise.all(
      items.map(async item =>
        item.kind === 'text' && item.types.has(RESOURCE_DRAG_TYPE)
          ? (JSON.parse(
              await item.getText(RESOURCE_DRAG_TYPE)
            ) as DraggedResource)
          : null
      )
    );
    return read.filter((resource): resource is DraggedResource =>
      Boolean(resource)
    );
  }
};
